"use client";
import { clickEvent } from "@/lib/atInternetTags";
import Link from "next/link";
import { Intermedes as LogoSVG } from "../icons/Intermedes";

type Props = {
  pathname?: string;
};
export const SMGLogo = ({ pathname = "/" }: Props) => {
  return (
    <Link
      href={{ pathname, query: {} }}
      className="flex items-center no-underline w-32 flex-[0_0_128px] xl:w-40 xl:flex-[0_0_160px] relative"
      onClick={() =>
        clickEvent({
          event: "click.navigation",
          click: "logo_intermedes",
          click_chapter1: "menu",
        })
      }
    >
      <LogoSVG className="w-full brightness-0 [clip-path:polygon(0_0,100%_0,100%_43%,0%_56%)] xl:[clip-path:polygon(0_0,100%_0,100%_50%,0%_70%)]" />
      <div className="absolute -bottom-1 xl:-bottom-2 left-0 right-0">
        <div
          style={{
            background: "linear-gradient(129deg, #202A5A 30.4%, #314593 72.59%)",
          }}
          className="flex items-center justify-center text-white px-1 rounded-xs text-[10px] xl:text-xs leading-none h-4 xl:h-5 font-medium origin-bottom-left -rotate-2"
        >
          VOYAGES EN GROUPE
        </div>
      </div>
    </Link>
  );
};
